import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=bb2d19e0&"
import script from "./SummaryCard.vue?vue&type=script&lang=js&"
export * from "./SummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports